import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Loading from "components/Loading";
import { toast } from "react-toastify";
import { useGetAllFeaturesQuery, useToggleFeatureMutation } from "App/services/featureServiceApi";

function Features() {
  const { data: features, isLoading, isFetching, refetch } = useGetAllFeaturesQuery();
  const [toggleFeature, { isLoading: toggling }] = useToggleFeatureMutation();
  const [pendingId, setPendingId] = useState(null);

  if (isLoading || isFetching) {
    return <Loading />;
  }

  const handleToggle = async (feature, checked) => {
    setPendingId(feature.id);
    try {
      await toggleFeature({ id: feature.id, is_enabled: checked }).unwrap();
      toast.success(`"${feature.name}" ${checked ? "enabled" : "disabled"} successfully`);
    } catch (err) {
      console.error("Failed to toggle feature:", err);
      toast.error(`Failed to ${checked ? "enable" : "disable"} "${feature.name}". Please try again.`);
      refetch();
    } finally {
      setPendingId(null);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <MDTypography variant="h6" color="white">
                  Features
                </MDTypography>
              </MDBox>
              <MDBox pt={2}>
                <TableContainer sx={{ maxHeight: 500 }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell>Feature</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell sx={{ textAlign: "center" }}>Status</TableCell>
                        <TableCell sx={{ textAlign: "center" }}>Enable / Disable</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {features && features.length > 0 ? (
                        features.map((feature) => (
                          <TableRow key={feature.id}>
                            <TableCell>
                              <MDTypography variant="button" fontWeight="medium">
                                {feature.name}
                              </MDTypography>
                            </TableCell>
                            <TableCell>{feature.description}</TableCell>
                            <TableCell sx={{ textAlign: "center" }}>
                              <Chip
                                label={feature.is_enabled ? "Applied" : "Not applied"}
                                color={feature.is_enabled ? "success" : "default"}
                                size="small"
                              />
                            </TableCell>
                            <TableCell sx={{ textAlign: "center" }}>
                              <Switch
                                checked={Boolean(feature.is_enabled)}
                                disabled={pendingId === feature.id || toggling}
                                onChange={(e) => handleToggle(feature, e.target.checked)}
                                inputProps={{ "aria-label": feature.name }}
                              />
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={4} sx={{ textAlign: "center" }}>
                            No features found
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Features;
